const artworks = [
  {
    id: 'rainbow-dragon',
    title: 'Rainbow Dragon',
    description: 'A fierce but friendly dragon soaring through a rainbow sky. Painted with bold, swirling strokes that capture the magic of imagination.',
    price: 25,
    medium: 'Watercolor on paper',
    size: '9" x 12"',
    stripePaymentLink: 'https://buy.stripe.com/placeholder-rainbow-dragon',
  },
  {
    id: 'underwater-castle',
    title: 'Underwater Castle',
    description: 'A sparkling castle at the bottom of the ocean, surrounded by colorful fish and friendly seahorses. Every window glows with golden light.',
    price: 30,
    medium: 'Acrylic on canvas',
    size: '11" x 14"',
    stripePaymentLink: 'https://buy.stripe.com/placeholder-underwater-castle',
  },
  {
    id: 'space-cat',
    title: 'Space Cat',
    description: 'A brave cat astronaut floating among the stars, chasing comets and discovering new planets. The galaxy has never looked so purrfect.',
    price: 20,
    medium: 'Colored pencil on paper',
    size: '8" x 10"',
    stripePaymentLink: 'https://buy.stripe.com/placeholder-space-cat',
  },
  {
    id: 'flower-garden-party',
    title: 'Flower Garden Party',
    description: 'Giant sunflowers, dancing daisies, and buzzing bees celebrate together in this vibrant garden scene full of joy and color.',
    price: 35,
    medium: 'Mixed media on canvas',
    size: '12" x 16"',
    stripePaymentLink: 'https://buy.stripe.com/placeholder-flower-garden-party',
  },
];

export function getArtworkById(id) {
  return artworks.find((artwork) => artwork.id === id);
}

export default artworks;
